import React from 'react';
import Icon from '../../../components/AppIcon';

const ExamplePromptCard = ({ title, description, prompt, icon, category, onClick }) => {
  return (
    <button
      onClick={() => onClick(prompt)}
      className="w-full text-left p-4 md:p-5 lg:p-6 bg-card border border-border rounded-lg hover:border-primary hover:shadow-lg transition-all duration-250 group"
    >
      <div className="flex items-start gap-3 md:gap-4 mb-3">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
          <Icon name={icon} size={20} className="text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="font-semibold text-sm md:text-base lg:text-lg truncate">{title}</h4>
            <span className="text-xs px-2 py-0.5 bg-muted rounded-full text-muted-foreground flex-shrink-0">
              {category}
            </span>
          </div>
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">{description}</p>
        </div>
      </div>
      <div className="bg-muted/50 rounded-md p-3 border border-border/50">
        <p className="text-xs md:text-sm text-foreground/80 line-clamp-3 font-mono">{prompt}</p>
      </div>
    </button>
  );
};

export default ExamplePromptCard;